import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "../assets/css/homepage_style.css";
import "../assets/css/landing-theme.css";
import "../assets/css/landing-layout.css";
// Stylesheets the previous landing sections pulled in. The page no longer uses them, but they are
// bundled app-wide, so they are kept here in the same order to leave the cascade of other pages unchanged.
import "../assets/css/navigation.css";
import "../assets/css/value_assembly_animation.css";
import "../assets/css/delivery_signal_animation.css";
import "../assets/css/feature_showcase.css";
import "../assets/css/hero_flow_animation.css";
import "../assets/css/footer.css";
import "../assets/css/ScrollToExplore.css";
import Landing from "./landing/Landing";

/** Landing page (route "/"). The redesign lives in ./landing and is scoped to that page only. */
function MainLayout() {
  return <Landing />;
}

export default MainLayout;
